import { createMuiTheme } from '@material-ui/core/styles';

/**
 * Customize the Material UI theme.
 * See https://material-ui.com/customization/themes.
 */
const theme = createMuiTheme({
  palette: {
    background: { default: '#a5a5af' },
    secondary: { main: '#015249' }
  },
  typography: {
    useNextVariants: true,
    h2: {
      fontSize: 40
    }
  }
});

export default theme;
